import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import CardContent from "@mui/joy/CardContent";
import Chip from "@mui/joy/Chip";
import Grid from "@mui/joy/Grid";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import PublicIcon from "@mui/icons-material/Public";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

export default function Popup({ estado, cerrar, perfil, edad }) {
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  /* MUESTRA CONTENIDO PRINCIPAL */

  let popupPerfil = () => {
    return (
      <div>
        <Modal
          open={estado}
          sx={{
            overflowY: "auto", // Habilita el scroll vertical para el modal completo
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ModalDialog sx={{ padding: "0px", border: "0px" }}>
            <ModalClose onClick={cerrar} variant="soft" color="neutral" />
            <Card variant="plain" sx={{ width: { md: 420, xs: "245" } }}>
              <CardOverflow>
                <AspectRatio ratio={0.8}>
                  <img
                    src={
                      perfil
                        ? `${linkimagen}/uploads/` + perfil.foto_de_perfil
                        : null
                    }
                    alt=""
                    loading="lazy"
                  />
                </AspectRatio>
              </CardOverflow>
              <CardContent>
                <Typography level="title-lg">
                  {perfil ? perfil.nombre : null}, {edad} años
                </Typography>
                <Typography level="body-sm">
                  {perfil ? perfil.intereses[0] : null}
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <Grid container spacing={1}>
                    {perfil
                      ? perfil.actividades.map((x) => {
                          return (
                            <Grid key={x.id}>
                              <Chip
                                size="sm"
                                sx={{ backgroundColor: "#EFE3C2" }}
                              >
                                {x}
                              </Chip>
                            </Grid>
                          );
                        })
                      : null}
                  </Grid>
                </Box>
              </CardContent>

              <CardContent sx={{ marginTop: "0.5rem" }}>
                <Card variant="soft">
                  <Box sx={{ display: "flex", marginBottom: "0.5rem" }}>
                    <Grid container spacing={1}>
                      <Grid sx={{ display: "flex", gap: 1 }}>
                        <PublicIcon />{" "}
                        <Typography level="body-sm">
                          {perfil
                            ? "De " + perfil.ciudad + ", " + perfil.pais
                            : null}
                        </Typography>
                      </Grid>
                      <Grid></Grid>
                    </Grid>
                  </Box>
                  <Typography level="title-md">Biografía</Typography>
                  <Typography level="body-sm">
                    {perfil ? perfil.descripcion_perfil : null}
                  </Typography>
                </Card>
              </CardContent>
              <CardContent sx={{ marginTop: "0.5rem" }}>
                <Box>
                  <ImageList cols={3} sx={{ borderRadius: "8px" }}>
                    {perfil
                      ? perfil.imagenes.map((x) => {
                          return (
                            <ImageListItem
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                setImagen(`${linkimagen}/uploads/` + x);
                              }}
                            >
                              <img
                                src={`${linkimagen}/uploads/` + x}
                                srcSet=""
                                alt=""
                                loading="lazy"
                              />
                            </ImageListItem>
                          );
                        })
                      : null}
                  </ImageList>
                </Box>
              </CardContent>
            </Card>
          </ModalDialog>
        </Modal>
      </div>
    );
  };

  /* MUESTRA CONTENIDO PRINCIPAL */

  /* MUESTRA IMAGEN SELECCIONADA */

  let [imagen, setImagen] = React.useState("");

  let galeria = () => {
    return (
      <Modal
        open={estado}
        sx={{
          overflowY: "auto", // Habilita el scroll vertical para el modal completo
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ModalDialog sx={{ padding: "0px", border: "0px" }}>
          <ModalClose
            onClick={() => {
              setImagen(null);
            }}
            variant="soft"
            color="neutral"
          />
          <Card
            variant="plain"
            sx={{ width: { md: 420, xs: "100%" }, padding: "0.1px" }}
          >
            <AspectRatio ratio={1}>
              <img src={imagen} alt="" />
            </AspectRatio>
          </Card>
        </ModalDialog>
      </Modal>
    );
  };
  /* MUESTRA IMAGEN SELECCIONADA */

  return <div>{imagen ? galeria() : popupPerfil()}</div>;
}
